import React, { Component } from "react"
import { connect } from "react-redux"
import ServiceCategoryGrid from "@components/layouts/global/ServiceCategoryGrid/ServiceCategoryGrid"
import ServiceGrid from "@components/layouts/global/ServiceGrid/ServiceGrid"
import SimpleIntro from "@components/layouts/global/SimpleIntro/SimpleIntro"
import Button from "@components/objects/Button/Button"
import hoppIconDark from "@images/icons/hoppIconDark.svg"
import blueRing from "@images/icons/hoppO.svg"
import pinkRing from "@images/icons/hoppOPink.svg"
import SiteWrapper from "../../structure/SiteWrapper/SiteWrapper"
import * as styles from "./OnBoarding.module.scss"

class OnBoarding extends Component {
  state = {
    step: "servicecategory",
    serviceCategoryServices: null,
  }

  updateStep = (step) => {
    this.setState({
      step: step,
    })
  }

  openServiceStep = (services) => {
    this.setState({
      serviceCategoryServices: services,
    })
    this.updateStep("service")
  }

  render() {
    const { categoryOptions, serviceCategoryOptions } = this.props.staticData

    const categoryIntro = {
      icon: hoppIconDark,
      title: "What are you looking for?",
      description: ``,
    }

    const serviceIntro = {
      icon: hoppIconDark,
      title: "Something more specific?",
      description: ``,
    }

    return (
      <div className={styles.OnBoarding}>
        <div className={styles.main}>
          <form onSubmit={(e) => this.handleSubmit(e)}>
            {(() => {
              switch (this.state.step) {
                case "servicecategory":
                  return (
                    <div>
                      <SimpleIntro {...categoryIntro} className={styles.featured} />
                      <ServiceCategoryGrid openServiceStep={this.openServiceStep} />
                    </div>
                  )
                case "service":
                  return (
                    <div>
                      <SimpleIntro {...serviceIntro} />
                      <ServiceGrid
                        categoryValue={this.state.categoryValue}
                        services={this.state.serviceCategoryServices}
                      />
                    </div>
                  )
                default:
                  return null
              }
            })()}
            <footer>
              <SiteWrapper className={styles.buttons}>
                {this.state.step === "service" && (
                  <Button
                    color="dark"
                    design="outline"
                    onClick={() => this.updateStep("servicecategory")}
                    text="Back"
                  />
                )}
                <Button
                  color="dark"
                  design="outline"
                  link="/suppliers-search/?loading=true"
                  text="Skip"
                />
              </SiteWrapper>
            </footer>
          </form>
        </div>
        <div className={styles.abstractImages}>
          <img src={blueRing} alt="" />
          <img src={pinkRing} alt="" />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return { staticData: state.staticData.data }
}

export default connect(mapStateToProps)(OnBoarding)
